import React from "react";
import { ClockIcon } from "lucide-react";
import { useCountdown } from "../hooks/useCountdown";
type CountdownProps = {
  tone?: "light" | "dark";
};
export function Countdown({
  tone = "light"
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: "Hours"
  }, {
    value: minutes,
    label: "Minutes"
  }, {
    value: seconds,
    label: "Seconds"
  }];
  const dark = tone === "dark";
  return <div className="mt-6 flex flex-col items-center" role="timer" aria-live="off" data-id="element-90" data-mp="3c48r4lqf57hz">
      <p className={`flex items-center gap-2 text-xs font-bold uppercase tracking-wider sm:text-sm ${dark ? "text-gold" : "text-navy"}`} data-id="element-91" data-mp="3h2abd9zkzcv1">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-92" data-mp="373kpl64kd89i" />
        Special offer ends in:
      </p>
      <div className="mt-3 flex items-start gap-2 sm:gap-3" data-id="element-93" data-mp="10dmwxh4j695w">
        {units.map((unit, i) => <React.Fragment key={unit.label} data-id="element-94" data-mp="15a4yk84kdre0" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-95" data-mp="1592821b5lqym">
              <span className={`flex h-16 w-16 items-center justify-center rounded-xl font-serif text-[32px] font-bold tabular-nums sm:h-20 sm:w-20 sm:text-4xl ${dark ? "bg-gold text-navy" : "bg-navy text-white"}`} data-id="element-96" data-mp="xzvh5a8mixzl">
                {unit.value}
              </span>
              <span className={`mt-1.5 text-[11px] font-semibold uppercase tracking-wide ${dark ? "text-white/60" : "text-muted"}`} data-id="element-97" data-mp="12tznpsdz9405">
                {unit.label}
              </span>
            </div>
            {i < units.length - 1 && <span className={`mt-3 font-serif text-3xl font-bold sm:mt-5 ${dark ? "text-gold" : "text-navy"}`} data-id="element-98" data-mp="o38z0t7oml19">:</span>}
          </React.Fragment>)}
      </div>
    </div>;
}